import React, { CSSProperties } from "react";
import { IETableState } from "./Interfaces";
import { ContainerEl } from "./index";
import * as Helpers from "./base/Helpers";

class ETable extends ContainerEl<HTMLTableElement, IETableState> {
    getStyles = (): CSSProperties => {
        let styles: CSSProperties = {
            backgroundColor: "transparent",
            border: 0,
            fontSize: this.props.Brand?.documentFontSize || 10,
            padding: 0,
            margin: 0,
            borderSpacing: 0,
            borderCollapse: "collapse",
        };

        return styles;
    };

    render(): JSX.Element {
        const { Brand, ...rest } = this.props;
        return (
            <table
                cellPadding={0}
                cellSpacing={0}
                width={"100%"}
                border={0}
                style={this.__setStyle(this.getStyles())}
                {...rest}
            >
                <tbody>{this.__passPropsToChildren({ Brand: Brand })}</tbody>
            </table>
        );
    }
}

export { ETable };
